export default "__VITE_ASSET__PZy8sqhY__"